import React from 'react';
import Button from '../../common/Button/Button';
import Modal from './Modal';

const ResetCartOnAdcChangeModal = props => {
  const { visible, onCancel, onOk } = props;
  return (
    <Modal
      onCancel={onCancel}
      wrapClassName="change-address-nudge"
      visible={visible}
      title="Change address?"
      getContainer={false}
    >
      <div>
        <div className="change-address-nudge--message">
          Changing address will empty your cart. <br />
          Do you want to change address?
        </div>
        <div className="justify-content--space-between">
          <Button className="button button-ghost" onClick={onCancel}>
            Cancel
          </Button>
          {/*<div className="merge-cart-on-login-modal--empty-padding"></div>*/}
          <Button className="button button-primary" onClick={onOk}>
            Change
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ResetCartOnAdcChangeModal;
